import { ExpandMore } from "@mui/icons-material";
import {
    Accordion,
    accordionClasses,
    AccordionDetails,
    AccordionSummary,
    accordionSummaryClasses,
} from "@mui/material";
import { ReactNode, useRef, useState } from "react";

export function SettingsPanel({ summary, children }: { summary: ReactNode; children: ReactNode }) {
    const [expanded, setExpanded] = useState(false);
    const accordionRef = useRef<HTMLDivElement | null>(null);
    const [collapsedWidth, setCollapsedWidth] = useState<number | null>(null);

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded((prev) => !prev)}
            sx={{
                pointerEvents: "auto",
                borderRadius: "8px",
                "&:last-of-type": { borderRadius: "8px" },
                width: collapsedWidth ?? "min-content",
                transition: "width 0.2s",
                [`&.${accordionClasses.expanded}`]: {
                    width: "100%",
                },
                "&::before": {
                    height: 0,
                },
            }}
            ref={(element) => {
                accordionRef.current = element;
                if (element && !collapsedWidth && !expanded) {
                    const width = Math.ceil(element.getBoundingClientRect().width);
                    setCollapsedWidth(width);
                }
            }}
            disableGutters
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                    flexDirection: "row-reverse",
                    gap: "8px",
                    padding: "8px 12px",
                    minHeight: "44px",
                    borderRadius: expanded ? "0px" : "8px",
                    [`&.${accordionSummaryClasses.expanded}`]: { minHeight: "44px" },
                    [`& .${accordionSummaryClasses.content}`]: { margin: 0 },
                }}
            >
                {summary}
            </AccordionSummary>
            <AccordionDetails
                sx={{ borderTop: "1px solid #D6DADC", padding: "8px 16px", display: "flex", flexDirection: "column" }}
            >
                {/* Don't render children until collapsedWidth is calculated, because children affect the width */}
                {collapsedWidth ? children : null}
            </AccordionDetails>
        </Accordion>
    );
}
